import React from 'react';
import {Box} from '../box';

export interface BigImageProps {
  image?: string | null;
  backgroundPosition?: 'center' | 'bottom' | 'top' | 'right' | 'left' | null;
  backgroundSize?: 'cover' | 'contain' | null;
}

export const BigImage: React.FC<BigImageProps> = ({
  image,
  backgroundPosition,
  backgroundSize,
}: BigImageProps) => {
  if (!image) return null;
  return (
    <Box
      backgroundRepeat="no-repeat"
      backgroundPosition={backgroundPosition || 'center'}
      backgroundSize={backgroundSize || 'cover'}
      width="100%"
      height={['720px']}
      padding="lg"
      css={{
        backgroundImage: `url(${image})`,
      }}
    />
  );
};
